
export default (width = 24, height = 24, color = '#797979') => `
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 24 24">
    <path fill="${color}" fill-rule="evenodd" stroke="${color}" d="M8.185 19.774c.3.301.799.301 1.11 0a.743.743 0 0 0 0-1.064l-5.624-5.45h18.552a.761.761 0 0 0 .776-.754.769.769 0 0 0-.776-.763H3.672L9.294 6.3c.3-.301.3-.785 0-1.075a.794.794 0 0 0-1.109 0l-6.952 6.742a.725.725 0 0 0 0 1.064l6.952 6.742z"/>
</svg>
`